<template>
  <!-- .skill -->
  <div class="skillset" :key="'set_' + skills.title">
    <div
        class="skill-unit"
        v-for="(items, index) in skills.details"
        :key="index.toString()"
        v-bind="items"
    >
      <h4>{{ items.language }}</h4>
      <!-- .skill-unit -->
      <div class="bar" :data-percent="items.bar">
        <div class="progress" :style="{ width: items.bar + '%' }"></div>
      </div>
      <!-- .skill-unit -->
    </div>
    <!-- .skill -->
  </div>
</template>

<script>
export default {
  name: "PowerBars",
  props: {
    skills: { type: Object, default: () => [] }
  }
};
</script>
